<script>
export default {
  props: {
    endDate: { type: Date, default: () => new Date() },
  },
  data: () => ({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  }),
  created() {
    setInterval(this.countTime, 1000)
  },
  methods: {
    countTime() {
      // Get today's date and time
      const now = new Date().getTime()

      // Find the distance between now and the count down date
      const countDownDate = this.endDate.getTime()
      const distance = countDownDate - now

      // Time calculations for days, hours, minutes and seconds
      this.days = Math.floor(distance / (1000 * 60 * 60 * 24))
      this.hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      )
      this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      this.seconds = Math.floor((distance % (1000 * 60)) / 1000)

      // If the count down is finished, do some job
      if (distance < 0) {
        clearInterval(this.countTime)
        this.$emit('expired')
      }
    },
  },
}
</script>

<template>
  <p>{{ days }}d {{ hours }}h {{ minutes }}m {{ seconds }}s</p>
</template>
